export default {"src":"/_next/static/media/cloud.cc8d77af.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};